import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

import { useDispatch, useSelector } from "react-redux";

// SERVICES
import { getAvailableDeliveryOrders } from "../../../api/order";
import { postShippingRouteOrder } from "../../../api/shipping";
// APP COMPONENTS
import CollapseAlert from "../../alerts/CollapseAlert";
// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { StyledModalRoot } from "../../styled/modal";
import { LightGreyBox } from "../../styled";
import { ButtonSuccessNoShadow } from "../../styled/button";
import ModalHeader from "../../modals/modalHeader";
import { setShowShippingRouteShowModal } from "../../../store/actions/shippingRoutesSlice";

export default function AvailableOrdersList({ show, loadRoutesData, onClose }) {
  const dispatch = useDispatch();

  const routeIdToAdd = useSelector(
    (state) => state.shippingRoutes.routeIdToAdd
  );

  const showShippingRouteShowModal = useSelector(
    (state) => state.shippingRoutes.showShippingRouteShowModal
  );

  const [availableOrders, setAvailableOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (show) {
      loadDataWithRetry();
    }
  }, [show]);

  const loadDataWithRetry = async () => {
    const maxRetries = 3;
    let retries = 0;

    while (retries < maxRetries) {
      try {
        await loadData();
        break; // Break out of the retry loop if loadData succeeds
      } catch (error) {
        console.error(`Attempt ${retries + 1} failed:`, error);
        retries++;
        // Optionally, you can add a delay between retries using setTimeout
        await new Promise((resolve) => setTimeout(resolve, 200)); // 1000ms delay
      }
    }

    if (retries === maxRetries) {
      console.error("Max retries reached. Failed to load data.");
    }
  };

  const loadData = async () => {
    try {
      const { data } = await getAvailableDeliveryOrders();

      const orders = data.map((order) => ({
        label: `Pedido ${order.order_index}`,
        value: order.order_id,
      }));

      setAvailableOrders(orders);
    } catch (e) {
      console.error(e);
    }
  };

  const submitAnswer = async () => {
    await createOrderRoute();
  };

  const createOrderRoute = async () => {
    try {
      if (!routeIdToAdd || !selectedOrder) {
        return await finishProccess();
      }

      const body = {
        id: uuidv4(),
        fk_route: routeIdToAdd,
        fk_order: selectedOrder,
      };
      await postShippingRouteOrder(body);

      await finishProccess();
    } catch (e) {
      console.log(e);
      setOpenErrorAlert(true);
      setErrorMessage(e.response.data.error);
    } finally {
    }
  };

  const finishProccess = async () => {
    try {
      await loadRoutesData();
      handleClose();
      dispatch(
        setShowShippingRouteShowModal({
          show: !showShippingRouteShowModal,
          id: routeIdToAdd,
        })
      );
    } catch (e) {
      console.error(e);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={show}
      onClose={handleClose}
      closeAfterTransition
      sx={{ zIndex: 9999 }}
    >
      <Fade in={show} unmountOnExit>
        <StyledModalRoot overflow={"auto"}>
          <ModalHeader label={"Atribuir Pedido à Entrega"} onClose={onClose} />
          <LightGreyBox>
            <Autocomplete
              size="small"
              disablePortal
              id="shipping-routes-options"
              noOptionsText="Nenhum Pedido Disponível Para Entrega"
              options={availableOrders}
              renderInput={(params) => <TextField {...params} label="Pedido" />}
              sx={{
                mt: 2,
                mb: 4,
              }}
              onChange={(event, values) => {
                setSelectedOrder(values?.value);
              }}
            />
            <ButtonSuccessNoShadow
              fullWidth
              type="submit"
              variant="contained"
              color="success"
              size="large"
              onClick={submitAnswer}
            >
              Adicionar
            </ButtonSuccessNoShadow>
          </LightGreyBox>

          <Box sx={{ mt: 1 }}>
            <CollapseAlert
              open={openErrorAlert}
              errorMessage={errorMessage}
              openErrorAlert={openErrorAlert}
              setOpenErrorAlert={setOpenErrorAlert}
              severity="error"
            />
          </Box>
        </StyledModalRoot>
      </Fade>
    </Modal>
  );
}
